import type { ChatInputVariant } from '@/types/chatInput';

export const CHAT_INPUT_PLACEHOLDER =
  'Describe what you\u2019d like to do. Type / for saved actions or @ to mention.';

export function getChatInputPlaceholder(_variant?: ChatInputVariant, _showTabs?: boolean): string {
  return CHAT_INPUT_PLACEHOLDER;
}
